<div class="weather-header">
  <div class="weather-header__left">
    <div class="weather-header__line1">
      <span class="weather-header__icon">
        <dsy-icon [name]="iconConfig(summary()).name" [library]="iconConfig(summary()).library" [size]="'1.5rem'"></dsy-icon>
      </span>
      <span class="weather-header__summary">{{ condition() | translate }}</span>
    </div>
    @if (temp() !== null) {
    <div class="weather-header__temp">
      <span class="weather-header__value">{{ temp() | number : '1.0-0' }}</span>
      <span class="weather-header__unit">°{{ unit() }}</span>
    </div>
    }
  </div>

  <div class="weather-header__right">
    <dr-flex-home-ui-search-results class="weather-header__search-results" (optionChosen)="onLocationSelected($event)"> </dr-flex-home-ui-search-results>
  </div>
</div>
